export * from './OptimizationLoader';

export enum OptimizationLoaderState {
    Hidden = 0,
    Visible = 1,
    VisibleCancellable = 2
}
